module.exports = __webpack_public_path__ + "resources/img/img_secureguard3.ab91283c27bb9802062c09b908ba86c6.png";